import { api } from "..";
const endpoint = "/api/inventory/transformations";

export const getTransformationList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getTransformationById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createTransformation = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateTransformation = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteTransformation = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
}; 